// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"b3-z","colorTextValue":"c3-z","swatches":"d3-z","collapseLink":"e3-z","isCollapsed":"f3-z","dropdown":"g3-z","disabled":"h3-z"};